import { ApiError } from "@/api/client";
import { DryRunBanner } from "@/components/DryRunBanner";
import { HealthCard } from "@/components/HealthCard";
import { useSystemHealth } from "@/hooks/useSystemHealth";

export function HealthPage() {
  const { data, isPending, error } = useSystemHealth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Salud del sistema</h1>
        <p className="text-sm text-muted-foreground">
          Refresco automático cada 30 segundos. El backend hace scraping a las métricas
          Prometheus de cada módulo.
        </p>
      </div>

      {data?.dry_run && <DryRunBanner />}

      {error && (
        <div
          role="alert"
          className="rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
        >
          {error instanceof ApiError ? error.message : "Error al cargar salud."}
        </div>
      )}

      {isPending && !data ? (
        <div className="rounded-md border bg-card p-8 text-center text-sm text-muted-foreground">
          Cargando…
        </div>
      ) : data ? (
        <div className="grid gap-4 md:grid-cols-3">
          {data.modules.map((module) => (
            <HealthCard key={module.name} module={module} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
